(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    

  async function removeOrphanAddonProducts() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();

      if (!cart.items || cart.items.length === 0) return;

      // Build maps: for each internal_id, detect if frame exists + collect addon keys
      const hasFrameById = {};     // { internal_id: true/false }
      const addonKeysById = {};    // { internal_id: [item.key, ...] }

      cart.items.forEach(item => {
        const internalId = item?.properties?._internal_id;
        if (!internalId) return;

        const id = String(internalId);

        if ((item.product_type || "").toLowerCase() === "addon") {
          if (!addonKeysById[id]) addonKeysById[id] = [];
          addonKeysById[id].push(item.key);
        } else {
          hasFrameById[id] = true;
        }
      });

      // Build updates: remove addon items for ids that have no frame
      const updates = {};
      let itemsToRemove = 0;

      Object.keys(addonKeysById).forEach(id => {
        const hasFrame = !!hasFrameById[id];
        if (!hasFrame) {
          addonKeysById[id].forEach(key => {
            updates[key] = 0;
            itemsToRemove++;
          });
        }
      });

      // Nothing orphaned
      if (itemsToRemove === 0) return;

      // Send update to Shopify
      const formData = new FormData();
      Object.keys(updates).forEach(key => {
        formData.append(`updates[${key}]`, updates[key]);
      });

      const removeResponse = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      });

      if (!removeResponse.ok) {
        throw new Error(`HTTP error! status: ${removeResponse.status}`);
      }

      // Reload cart page
      window.location.href = "/cart";
    } catch (error) {
      console.error("Error removing orphan addon products:", error);
    }
  }

  // Click handler for bundle removal
  document.addEventListener('click', async function(event) {

    const button = event.target.closest('a[data-bundle-removal]');
    if (!button) return;

    event.preventDefault();

    // Prevent double-clicks
    if (button.classList.contains('is-removing')) return;

    const internalId = button.getAttribute('data-intern-id');
    const originalText = button.textContent;
    
    button.classList.add('is-removing');
    button.textContent = 'Removing...';

    try {
      // Fetch cart data from Shopify
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) {
        throw new Error('Failed to fetch cart data');
      }
      const cart = await cartResponse.json();

      // Find all items in cart with matching internal_id
      const updates = {};
      let itemsFound = 0;

      cart.items.forEach(item => {
        // Check if item has internal_id property matching our target
        if (item.properties && item.properties._internal_id === internalId) {
          updates[item.key] = 0;  // Set quantity to 0 to remove
          itemsFound++;
        }
      });

      if (itemsFound === 0) {
        console.error('No products found in cart with this internal ID!');
        //button.textContent = 'Not Found';
        setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove('is-removing');
        }, 2000);
        return;
      }

      // Create FormData for the update request
      const formData = new FormData();
      
      // Append each update individually - Shopify expects updates[key]=quantity format
      Object.keys(updates).forEach(key => {
        formData.append(`updates[${key}]`, updates[key]);
      });

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Success - show message and redirect to cart
      //button.textContent = `Removed ${itemsFound} item(s)!`;

      // Redirect to cart after short delay to show the success message
      setTimeout(() => {
        window.location.href = "/cart";
      }, 1000);

    } catch (error) {
      console.error('Error removing products:', error);
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = originalText;
        button.classList.remove('is-removing');
      }, 2000);
    }
});

// Auto-remove orphan addons on page load
document.addEventListener("DOMContentLoaded", removeOrphanAddonProducts);


  } catch(e) { console.error(e); }
})();
})();
